import { ApiConfigs } from "../configs/ApiConfigs";
import { OrganizationInfo } from "../models/api-models/organization/organization-info";
import { HttpUtility } from "../utilities/HttpUtility";
import { Api } from "./Api";

export class PolicyApi {
    private static get omniMessagingApiUrl(): string {
        return HttpUtility.combine(ApiConfigs.omniMessagingUrl, 'v1/organization');
    }

    static async getOrganizationInfo(organizationMnemonic: string): Promise<OrganizationInfo> {
        let url = HttpUtility.combine(this.omniMessagingApiUrl, encodeURIComponent(organizationMnemonic), 'public-info');
        return await Api.get<OrganizationInfo>(url);
    }
}